import { type NextRequest, NextResponse } from "next/server";
import { updateSession } from "@/utils/supabase/middleware";
import { i18nRouter } from "next-i18n-router";
import { i18nRouterConfig } from "@/app/i18n/config";

export async function middleware(request: NextRequest) {
  const response = await updateSession(request);

  if (response) {
    return response;
  }

  return i18nRouter(request, i18nRouterConfig);
}

export const config = {
  matcher: [
    "/((?!_next/static|_next/image|favicon.ico|.*\\.(?:svg|png|jpg|jpeg|gif|webp)$|api|static|.*\\..*).*)",
  ],
};
